<template>
  <div
    class="condition-row"
    :draggable="dragId === condition.id"
    @dragstart="onDragStart($event)"
    @dragover.prevent
    @drop="onDrop($event)"
  >
    <div class="condition-inner">
      <div class="row-toolbar">
        <!-- <custom-drop-down
          :defaultStyle="{ dropDownWidth: '80px' }"
          :selected="selectedConnector"
          :list="connectorOptions"
          class="connector-dropdown"
          @select="selectConnector"
        /> -->
        <!-- hide/show control disabled for single-condition mode -->
        <!-- <div class="toggle-btn v-center" @click="toggleExpand">
        <img v-if="isExpanded" src="~@/assets/images/icons/hide-eye.svg" alt="" width="12px" >
          <img v-else src="~@/assets/images/icons/open-eye.svg" width="12px" >
          {{ isExpanded ? 'Hide' : 'Show' }}
        </div> -->
      </div>

      <transition
        name="row-expand"
        @before-enter="beforeExpandEnter"
        @enter="onExpandEnter"
        @after-enter="afterExpandEnter"
        @before-leave="beforeExpandLeave"
        @leave="onExpandLeave"
        @after-leave="afterExpandLeave"
      >
        <div v-show="isExpanded" class="expandable-body">
          <div class="condition-fields">
            <span class="where-label">Where</span>

            <custom-drop-down
              :defaultStyle="{ dropDownWidth: '100%', ddMaxWidth: 'none' }"
              :selected="selectedField"
              :list="fieldOptions"
              :disabled="!isEditable"
              class="field-dropdown"
              @select="selectField"
            />

            <custom-drop-down
              :defaultStyle="{ dropDownWidth: '100%', ddMaxWidth: 'none' }"
              :selected="selectedOperator"
              :list="operatorOptions"
              :disabled="!isEditable"
              class="operator-dropdown"
              @select="selectOperator"
            />

            <div class="value-dropdown-wrapper" v-click-outside="() => closeValueDropdown()">
              <div
                ref="valueDropdownTrigger"
                class="value-dropdown-trigger"
                :class="{ open: isValueDropdownOpen, disabled: !isEditable }"
                @click="toggleValueDropdown"
              >
                <div class="selected-tags">
                  <span
                    v-for="val in condition.values"
                    :key="val"
                    class="tag"
                  >
                    {{ getOptionLabel(val) }}
                    <button v-if="isEditable" class="tag-remove" @click.stop="removeValue(val)">x</button>
                  </span>
                  <span v-if="!condition.values || condition.values.length === 0" class="placeholder">Select...</span>
                </div>
                <svg class="chevron" :class="{ rotated: isValueDropdownOpen }" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2 4l4 4 4-4" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>

              <div
                v-if="isValueDropdownOpen"
                ref="valueDropdownMenu"
                class="value-dropdown-menu"
                :class="{ 'value-dropdown-menu--up': valueDropdownOpenUpward }"
                :style="valueDropdownStyle"
              >
                <template v-if="isMultiSelect">
                  <label
                    v-for="option in valueOptions"
                    :key="option.id"
                    class="checkbox-option"
                  >
                    <input
                      type="checkbox"
                      :disabled="!isEditable"
                      :checked="isValueChecked(option.id)"
                      @change="toggleValue(option.id)"
                    >
                    <span class="checkmark" :class="{ checked: isValueChecked(option.id) }">
                      <svg v-if="isValueChecked(option.id)" width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <path d="M2 5l2.5 2.5L8 3" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                    <span class="option-label">{{ option.name }}</span>
                  </label>
                </template>
                <template v-else>
                  <button
                    v-for="option in valueOptions"
                    :key="option.id"
                    type="button"
                    class="option-row"
                    :disabled="!isEditable"
                    :class="{ selected: isValueChecked(option.id) }"
                    @click="selectSingleValue(option.id)"
                  >
                    {{ option.name }}
                  </button>
                </template>
              </div>
            </div>

            <!-- delete disabled for single-condition mode -->
            <!-- <button class="icon-btn" type="button" @click="$emit('remove-condition', condition.id)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2"><polyline points="3,6 5,6 21,6"/><path d="M19,6l-1,14H6L5,6"/><path d="M10,11v6M14,11v6"/><path d="M9,6V4h6v2"/></svg>
            </button> -->
          </div>

          <div class="nested-slot">
            <slot name="nested"></slot>
          </div>

          <!-- <div class="add-actions">
            <button
              class="add-btn"
              type="button"
              @click="$emit('add-subgroup', condition.id)"
              v-if="allowSubgroup && !hasChildren"
            >
              <span>+</span> Add subgroup
            </button>
          </div> -->
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import CustomDropDown from '@/components/common/customDropdown.vue'

export default {
  name: 'ConditionRow',
  components: { CustomDropDown },
  directives: {
    'click-outside': {
      bind (el, binding) {
        el._clickOutsideHandler = (event) => {
          if (!el.contains(event.target)) {
            binding.value(event)
          }
        }
        document.addEventListener('click', el._clickOutsideHandler)
      },
      unbind (el) {
        document.removeEventListener('click', el._clickOutsideHandler)
      }
    }
  },
  props: {
    condition: {
      type: Object,
      required: true
    },
    fieldOptions: {
      type: Array,
      default: () => []
    },
    operatorOptions: {
      type: Array,
      default: () => []
    },
    valueOptions: {
      type: Array,
      default: () => []
    },
    dragId: {
      type: [String, Number],
      default: null
    },
    allowSubgroup: {
      type: Boolean,
      default: true
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      connectorOptions: [
        { id: 'and', name: 'and' },
        { id: 'or', name: 'or' }
      ],
      isExpanded: true,
      valueDropdownStyle: {},
      valueDropdownOpenUpward: false
    }
  },
  computed: {
    selectedConnector () {
      const id = this.condition.logicalOperator || 'and'
      return { id, name: id }
    },
    selectedField () {
      const id = this.condition.field || this.fieldOptions[0]?.id || ''
      const matchedField = this.fieldOptions.find(option => option.id === id)
      return matchedField || { id, name: id }
    },
    selectedOperator () {
      const id = this.condition.operator || ''
      return { id, name: id }
    },
    hasChildren () {
      return Array.isArray(this.condition.children) && this.condition.children.length > 0
    },
    isValueDropdownOpen () {
      return !!this.condition.valueDropdownOpen
    },
    isMultiSelect () {
      return this.condition.operator === 'contains'
    }
  },
  methods: {
    emitPatch (patch) {
      this.$emit('update-condition', { id: this.condition.id, patch })
    },
    toggleExpand () {
      this.isExpanded = !this.isExpanded
    },
    beforeExpandEnter (el) {
      el.style.height = '0'
      el.style.opacity = '0'
      el.style.overflow = 'hidden'
    },
    onExpandEnter (el) {
      el.style.height = `${el.scrollHeight}px`
      el.style.opacity = '1'
    },
    afterExpandEnter (el) {
      el.style.height = 'auto'
      el.style.overflow = ''
    },
    beforeExpandLeave (el) {
      el.style.height = `${el.scrollHeight}px`
      el.style.opacity = '1'
      el.style.overflow = 'hidden'
    },
    onExpandLeave (el) {
      window.requestAnimationFrame(() => {
        el.style.height = '0'
        el.style.opacity = '0'
      })
    },
    afterExpandLeave (el) {
      el.style.height = ''
      el.style.overflow = ''
    },
    selectConnector (item) {
      if (!this.isEditable) {
        return
      }
      this.emitPatch({ logicalOperator: item.id })
    },
    selectField (item) {
      if (!this.isEditable) {
        return
      }
      this.emitPatch({ field: item.id })
    },
    selectOperator (item) {
      if (!this.isEditable) {
        return
      }
      const currentValues = this.condition.values || []
      const nextValues = item.id === 'contains'
        ? currentValues
        : currentValues.slice(0, 1)
      this.emitPatch({ operator: item.id, values: nextValues })
    },
    toggleValueDropdown () {
      if (!this.isEditable) {
        return
      }
      const nextState = !this.isValueDropdownOpen
      this.emitPatch({ valueDropdownOpen: nextState })
      if (nextState) {
        this.$nextTick(() => {
          this.positionValueDropdown()
          window.addEventListener('resize', this.positionValueDropdown)
          window.addEventListener('scroll', this.positionValueDropdown, true)
        })
      } else {
        this.resetValueDropdownPosition()
      }
    },
    closeValueDropdown () {
      this.resetValueDropdownPosition()
      this.emitPatch({ valueDropdownOpen: false })
    },
    resetValueDropdownPosition () {
      this.valueDropdownStyle = {}
      this.valueDropdownOpenUpward = false
      window.removeEventListener('resize', this.positionValueDropdown)
      window.removeEventListener('scroll', this.positionValueDropdown, true)
    },
    positionValueDropdown () {
      if (!this.isValueDropdownOpen) {
        return
      }
      const trigger = this.$refs.valueDropdownTrigger
      if (!trigger) {
        return
      }

      const triggerRect = trigger.getBoundingClientRect()
      const viewportPadding = 8
      const preferredHeight = 280
      const spaceBelow = window.innerHeight - triggerRect.bottom - viewportPadding
      const spaceAbove = triggerRect.top - viewportPadding
      const shouldOpenUpward = spaceBelow < 180 && spaceAbove > spaceBelow
      const availableHeight = shouldOpenUpward ? spaceAbove : spaceBelow
      const menuMaxHeight = Math.max(Math.min(availableHeight - 8, preferredHeight), 120)

      this.valueDropdownOpenUpward = shouldOpenUpward
      this.valueDropdownStyle = {
        position: 'fixed',
        left: `${triggerRect.left}px`,
        width: `${triggerRect.width}px`,
        top: shouldOpenUpward ? 'auto' : `${triggerRect.bottom + 4}px`,
        bottom: shouldOpenUpward ? `${window.innerHeight - triggerRect.top + 4}px` : 'auto',
        maxHeight: `${menuMaxHeight}px`,
        zIndex: 10050
      }
    },
    getOptionLabel (value) {
      const matchedOption = this.valueOptions.find(option => String(option.id) === String(value))
      return matchedOption?.name || value
    },
    isValueChecked (option) {
      return (this.condition.values || []).some(value => String(value) === String(option))
    },
    toggleValue (option) {
      if (!this.isEditable) {
        return
      }
      const currentValues = this.condition.values || []
      const exists = currentValues.includes(option)
      let nextValues = []
      if (this.isMultiSelect) {
        nextValues = exists
          ? currentValues.filter(val => val !== option)
          : [...currentValues, option]
      } else {
        nextValues = exists ? [] : [option]
      }

      this.emitPatch({
        values: nextValues,
        valueDropdownOpen: this.isMultiSelect
      })
      if (!this.isMultiSelect) {
        this.closeValueDropdown()
      }
    },
    selectSingleValue (option) {
      if (!this.isEditable) {
        return
      }
      this.emitPatch({ values: [option] })
      this.closeValueDropdown()
    },
    removeValue (value) {
      if (!this.isEditable) {
        return
      }
      const currentValues = this.condition.values || []
      const nextValues = currentValues.filter(val => val !== value)
      this.emitPatch({ values: nextValues })
    },
    onDragStart (event) {
      this.$emit('drag-start', { condition: this.condition, event })
    },
    onDrop (event) {
      this.$emit('drop', { condition: this.condition, event })
    }
  },
  beforeDestroy () {
    this.resetValueDropdownPosition()
  }
}
</script>

<style scoped lang="scss">
$color-primary: #7c3aed;
$color-primary-dark: #6d28d9;
$color-primary-light: #ede9fe;
$color-primary-focus-bg: #f5f3ff;
$color-primary-shadow: rgba(124, 58, 237, 0.1);
$color-white: #ffffff;
$color-bg-hover: #f3f4f6;
$color-border-base: #e5e7eb;
$color-border-input: #d1d5db;
$color-border-hover: #9ca3af;
$color-text-secondary: #374151;
$color-text-muted: #6b7280;
$color-text-placeholder: #9ca3af;
$shadow-dropdown: 0 4px 16px rgba(0, 0, 0, 0.1);
$font-size-sm: 12px;
$font-size-base: 13px;
$font-size-md: 14px;

.condition-row {
  margin-bottom: 8px;
}

.condition-inner {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.row-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  & .toggle-btn{
  justify-self: flex-end;
    & img{
      filter: grayscale(100%) brightness(70%);
    }
  }
}

.toggle-btn {
  background: none;
  // border: 1px solid $color-border-base;
  // border-radius: 6px;
  cursor: pointer;
  color: $color-text-muted;
  font-size:var(--text-xs2);
  gap: 5px;
  // padding: 4px 8px;

  &:hover {
    // background: $color-bg-hover;
  }
}

.condition-fields {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
}

.expandable-body {
  overflow: visible;
}

.row-expand-enter-active,
.row-expand-leave-active {
  transition: height 340ms ease, opacity 300ms ease;
}

.where-label {
  font-size: $font-size-sm;
  color: $color-text-muted;
  min-width: 36px;
}

.field-dropdown {
  width: 100%;
  min-width: 0;
}

.operator-dropdown {
  width: 100%;
  min-width: 0;
}

.value-dropdown-wrapper {
  position: relative;
  width: 100%;
  min-width: 0;
}

@media (max-width: 700px) {
  .condition-fields {
    grid-template-columns: 1fr;
  }
}

.value-dropdown-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 32px;
  padding: 4px 8px;
  border: 1px solid $color-border-input;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  gap: 6px;
  transition: border-color 0.15s;

  &:hover {
    border-color: $color-border-hover;
  }

  &.open {
    border-color: $color-primary;
    box-shadow: 0 0 0 2px $color-primary-shadow;
  }

  &.disabled {
    background: #f3f4f6;
    cursor: not-allowed;
  }
}

.selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  flex: 1;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  background: $color-primary-light;
  color: $color-primary-dark;
  border-radius: 4px;
  padding: 1px 6px;
  font-size: $font-size-sm;
  font-weight: 500;
}

.tag-remove {
  background: none;
  border: none;
  cursor: pointer;
  color: $color-primary;
  font-size: $font-size-md;
  line-height: 1;
  padding: 0;
  display: flex;
  align-items: center;
}

.placeholder {
  color: $color-text-placeholder;
  font-size: $font-size-sm;
}

.chevron {
  flex-shrink: 0;
  transition: transform 0.2s;

  &.rotated {
    transform: rotate(180deg);
  }
}

.value-dropdown-menu {
  background: $color-white;
  border: 1px solid $color-border-base;
  border-radius: 8px;
  box-shadow: $shadow-dropdown;
  z-index: 9999;
  padding: 4px 0;
  min-width: 200px;
  overflow: auto;
}

.value-dropdown-menu--up {
  transform-origin: bottom center;
}

.checkbox-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  cursor: pointer;

  &:hover {
    background: $color-primary-focus-bg;
  }

  input[type='checkbox'] {
    display: none;
  }
}

.checkmark {
  width: 16px;
  height: 16px;
  border: 1.5px solid $color-border-input;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: $color-white;

  &.checked {
    background: $color-primary;
    border-color: $color-primary;
  }
}

.option-label {
  font-size: $font-size-base;
  color: $color-text-secondary;
}

.option-row {
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
  font-size: $font-size-base;
  color: $color-text-secondary;
  padding: 8px 14px;
  cursor: pointer;

  &:hover {
    background: $color-primary-focus-bg;
  }

  &.selected {
    color: $color-primary-dark;
    background: rgba(124, 58, 237, 0.08);
    font-weight: 600;
  }
}

.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $color-text-placeholder;
  transition: background 0.15s;
  flex-shrink: 0;

  &:hover {
    background: $color-bg-hover;
  }
}

.add-actions {
  display: flex;
  gap: 12px;
  padding: 6px 0 4px;
}

.add-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: $color-primary;
  font-size: $font-size-sm;
  font-weight: 500;
  padding: 4px 6px;
  border-radius: 4px;
  transition: background 0.15s;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    background: $color-primary-focus-bg;
  }
}
</style>
